const m = window.require("discourse/helpers/concat-class");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;